import React, { useEffect } from "react";
import HTMLReactParser from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import { DragescentState } from "../../../store/reducers/stateType";
import { NotificationInfo } from "../../../lib/types";
import { setNotificationRead, setNotificationsSeen } from "../../../store/actions";

const PlayersMenu = () => {
  const notifications = useSelector(
    (state: DragescentState) => state.governorate.player.notifications
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (notifications.some((notification: NotificationInfo) => notification.unseen)) {
      dispatch(setNotificationsSeen());
    }
  }, [])

  return (
    <>
      <div className="dialog-content" style={{ padding: 0, minHeight: 0 }}>
        {notifications.map((notification: NotificationInfo) => (
            <ul key={notification.id}>
              <li className="item">
                <span className="link">{HTMLReactParser(notification.message)}</span>
                <a
                   className="dismiss"
                   title="Close"
                   onClick={() => dispatch(setNotificationRead(notification.id))}
                >
                  &times;
                </a>
              </li>
            </ul>))}
       </div>
      <footer className="dialog-footer">
        <a href={`${process.env.REACT_APP_API_URL}/logout`} data-forward-url="/logout" className="link">Log out</a>
        <a href={`${process.env.REACT_APP_API_URL}/account/display`} className="link">Player's account</a>
        <a className="disabled">Read all</a>
      </footer>
    </>
  )
}

export default PlayersMenu;
